module.exports = __webpack_public_path__ + "h5/img/fenc-end.bdb523cb.jpg";